var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "375", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "not-afiliation-finalized" },
        [
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-close",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("h1", { staticClass: "px-" }, [
                    _vm._v(
                      "¿Por qué motivo no ha sido concretada la afiliación?"
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "mt-1 py-0" },
                [
                  _c(
                    "v-radio-group",
                    {
                      attrs: { column: "" },
                      model: {
                        value: _vm.reason,
                        callback: function($$v) {
                          _vm.reason = $$v
                        },
                        expression: "reason"
                      }
                    },
                    [
                      _vm._l(_vm.radios, function(item, i) {
                        return [
                          _c("v-radio", {
                            key: i,
                            staticClass: "mb-4 radio-btn",
                            attrs: { label: item, value: i, color: "orange" }
                          })
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "pt-0",
                      attrs: {
                        "align-center": "",
                        "justify-center": "",
                        column: "",
                        "fill-height": ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-button mb-3",
                          on: { click: _vm.returnModal }
                        },
                        [_vm._v("Regresar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-button mb-1 ml-0",
                          on: { click: _vm.close }
                        },
                        [_vm._v("Finalizar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b2a2596", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2a2596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/not-affiliation-finalized.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0b2a2596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/not-affiliation-finalized.vue
// module chunks = 34